import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { FieldConfig } from "../../interface/field.interface";
@Component({
    selector: 'dynamic-form',
    templateUrl: './dynamic-form.component.html'
})
export class DynamicFormComponent implements OnInit, AfterViewInit {
    @Input() repeatCount: number = 0;
    @Input() disabled: boolean = false;
    @Input() fields: FieldConfig[] = [];
    @Input() name: string = '';
    @Output() submit: EventEmitter<any> = new EventEmitter<any>();
    subFields: FieldConfig[] = [];
    copyFields: FieldConfig[] = [];
    form!: FormGroup;
    constructor(private fb: FormBuilder) {
    }

    ngOnInit() {
    }
    ngAfterViewInit() {
    }

    createControl() {
        const group = this.fb.group({});
        this.fields.forEach((field:any) => {
            if (field.type === "button") return;
            // For EIP DateRange Control, need to store start & end date value in form object
            if (field.type === "eipdaterange") {
                field.rangeControlNames?.forEach((val:any) => {
                    const control = this.fb.control('');
                    group.addControl(val, control);
                })
            }
            else {
                let formState: any;
                //Update selected value
                if (!!field.value) {
                    let selectedDedId: any = field.value.value;
                    if (!!selectedDedId)
                        formState = field.value.value;
                }
                const control = this.fb.control(
                    formState,
                    this.bindValidations(field.validations || [])
                );
                if (this.disabled) {
                    control.disable();
                }
                if(field.name)
                group.addControl(field.name, control);
                //form control for EIP Autocomplete component (Select component)
                if (field.type == "select") {
                    const formControl = this.fb.control(
                        formState,
                        this.bindValidations(field.validations || [])
                    );
                    group.addControl("form" + field.name, formControl);
                }
            }
        });
        this.form = group;
    }

    get value(): FormGroup {
        return this.form;
    }

    bindValidations(validations: any) {
        if (validations.length > 0) {
            const validList: any[] = [];
            validations.forEach((valid: { validator: any; }) => {
                validList.push(valid.validator);
            });
            return Validators.compose(validList);
        }
        return null;
    }

    getCascadingAutocompleteDetails(name:any) {
        return this.fields.filter((data:any) => data.deDescription.trim() == name);
    }

    isNewRow(index: number): boolean {
        this.copyFields = [...this.fields];
        if (index == 1 || index % this.repeatCount == 1) {
            this.subFields = this.copyFields.splice(index - 1, this.repeatCount);
            return true;
        }
        return false;
    }

    getColClass(): string {
        return "col-" + Number(12 / this.repeatCount);
    }

    fieldsLoaded(): boolean {
        return this.fields.length > 0;
    }
}
